<template>
  <q-section v-bind="$attrs" p="relative">
    <q-section
      p="relative"
      :bg-i="uiMeta.images[`textBg${rankType + 1}`]"
      :key="`textBg${rankType + 1}`"
      v-bind="uiMeta.layout.textConfig"></q-section>
    <q-section
      v-if="showRewardDetail"
      :bg-i="uiMeta.images.rankDetailBg || 'rank-look-detail'"
      v-bind="rewardDetailPosition || uiMeta.layout.rankDetailConfig"
      @click="toRule"></q-section>
    <Top3 :top3="top3" p="relative" v-bind="uiMeta.layout.top3WrapperConfig" @avatar-click="handleAvatarClick" />
    <RankList
      p="relative"
      :listother="listother"
      v-bind="uiMeta.layout.otherListWrapperConfig"
      @avatar-click="handleAvatarClick" />
    <RankMine
      v-if="mine"
      :mineRank="mine"
      v-bind="uiMeta.layout.mineWrapperConfig"
      @click="handleClick"
      @avatar-click="handleAvatarClick" />
  </q-section>
</template>

<script setup lang="ts">
import { useRank } from './use-rank'
import { useRouter } from 'vue-router'
import Top3 from './top3.vue'
import RankList from './rank-list.vue'
import RankMine from './rank-mine.vue'

const props = defineProps({
  uiMeta: {
    type: Object,
    default: () => {},
  },
  showRewardDetail: {
    type: Boolean,
    default: false,
  },
  rewardDetailPosition: {
    type: Object,
  },
})

const { mine, top3, listother, rankType, handleClick, handleAvatarClick } = useRank(props.uiMeta, {})

const router = useRouter()

const toRule = () => {
  router.push({
    path: props.uiMeta.config.detailRouter,
    query: {
      target: props.uiMeta.config.targetRuleTab,
    },
  })
}
</script>

<style scoped lang="scss"></style>
